/* eslint-disable import/prefer-default-export */
export const navigateExternal = (path) => {
  window.location.href = path;
};
